var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"report"},[_c('div',{staticClass:"content"},_vm._l((_vm.reportList),function(item,index){return _c('div',{key:index,staticClass:"item"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(item.title))]),_c('div',{staticClass:"button",on:{"click":_vm.openPayment}},[_vm._v("10元阅读")])])}),0),_c('Payment',{ref:"Payment"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }